import Coin from "@/assets/svg/creator-shield/bg-icons/coin-live.svg";
import DollarCoin from "@/assets/svg/creator-shield/bg-icons/dollar-coin-live.svg";
import FilePlay from "@/assets/svg/creator-shield/bg-icons/file-play-live.svg";
import Film from "@/assets/svg/creator-shield/bg-icons/film-live.svg";
import Fingerprint from "@/assets/svg/creator-shield/bg-icons/fingerprint-live.svg";
import FolderSeach from "@/assets/svg/creator-shield/bg-icons/folder-search-live.svg";
import ShieldCheckOutline from "@/assets/svg/creator-shield/bg-icons/shield-check-live.svg";
import Video from "@/assets/svg/creator-shield/bg-icons/video-live.svg";
import Recorder from "@/assets/svg/creator-shield/recorder.svg";
import { CSPrimaryBtn, CSTertiaryBtn } from "@/components/design-system/creatorshield/CSButton";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import scrollTo from "@/utils/scrollTo";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Statistics from "../Statistics";
import ShieldCheck from "@/assets/svg/creator-shield/shield-check.svg";

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const headlineRef = useScrollAnimation({ threshold: 0.2 });

  const handleScrollTo = (targetPath, scrollId) => {
    if (location.pathname === targetPath) {
      scrollTo(scrollId);
    } else {
      navigate(targetPath, { state: { scrollTo: scrollId } });
    }
  };

  return (
    <div id="live-benefits" className="bg-white pt-[120px] pb-16 px-6 md:px-16 relative overflow-visible space-y-16">
      <div className="4xl:max-w-[100rem] 4xl:mx-auto relative space-y-10">
        {/* Built for Streamers Badge */}
        <div className="flex justify-center">
          {/* MOBILE: mb-[-6px] mt-4 | DESKTOP: lg:mb-... lg:mt-... - customize margin here */}
          <div className="flex items-center gap-2 border border-border rounded-full px-4 py-2 mb-[-15px] mt-[-0px]">
            <img src={Recorder} alt="Telephone Icon" className="w-5 h-5" />
            <span className="font-normal text-black leading-normal whitespace-nowrap">
              Built for Streamers
            </span>
          </div>
        </div>

        {/* Main Headline */}
        <div ref={headlineRef} className="text-center space-y-6 animate-fade-rise">
          <h1 className="text-5xl lg:text-7xl font-bold leading-tight">
            <span className="text-[#9333EA]">Streamers, </span> Listen Up
            <br />
            <span className="text-black">
              Reclaim Your{" "}
              <span className="text-[#FF6B35]">Lost Revenue</span>
            </span>
          </h1>
          <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto">
            We help streamers recover ad revenue from reuploads of streams,
            highlights, and clips. Join 3,500+ creators who've already recouped
            $50M+.
          </p>
        </div>

        {/* Decorative Floating Icons */}
        <div className="absolute left-[calc(50%+600.7px)] top-[458px] translate-x-[-50%] w-[79.391px] h-[79.391px] items-center justify-center transform rotate-[540deg] hidden lg:flex">
          <img
            src={FolderSeach}
            alt="Decorative Icon"
            className="w-[62px] h-[62px] slow-spin"
            style={{ animationDelay: '0s' }}
          />
        </div>
        <div className="absolute left-[calc(50%+460px)] -top-[30px] translate-x-[-50%] w-[73.485px] h-[73.485px] items-center justify-center transform rotate-[155deg] hidden lg:flex">
          <img
            src={Video}
            alt="Decorative Icon"
            className="w-[60px] h-[60px] slow-spin"
            style={{ animationDelay: '0s' }}
          />
        </div>
        <div className="absolute left-[calc(50%-530.16px)] top-[441px] translate-x-[-50%] w-[71.685px] h-[71.685px] items-center justify-center transform rotate-[9.842deg] hidden lg:flex">
          <img
            src={Fingerprint}
            alt="Decorative Icon"
            className="w-[62px] h-[62px] slow-spin"
            style={{ animationDelay: '0s' }}
          />
        </div>
        <div className="absolute left-[calc(50%-550px)] -top-[30px] translate-x-[-50%] w-[76.282px] h-[76.282px] items-center justify-center transform rotate-[340.974deg] hidden lg:flex z-10">
          <img src={Coin} alt="Decorative Icon" className="w-[60px] h-[60px] slow-spin" style={{ animationDelay: '3s' }} />
        </div>
        <div className="absolute left-[calc(50%-645.37px)] top-[615px] translate-x-[-50%] w-[77.266px] h-[77.266px] items-center justify-center transform rotate-[343.211deg] hidden xl:flex">
          <img
            src={ShieldCheckOutline}
            alt="Decorative Icon"
            className="w-[62px] h-[62px] slow-spin"
            style={{ animationDelay: '0s' }}
          />
        </div>
        <div className="absolute left-[calc(50%-650px)] top-[160px] translate-x-[-50%] w-[57.33px] h-[57.33px] items-center justify-center transform rotate-[345.4deg] hidden xl:flex">
          <img
            src={FilePlay}
            alt="Decorative Icon"
            className="w-[47px] h-[47px] slow-spin"
            style={{ animationDelay: '0s' }}
          />
        </div>
        <div className="absolute left-[calc(50%+650px)] top-[185px] translate-x-[-50%] w-[58.731px] h-[58.731px] items-center justify-center transform rotate-[334.293deg] hidden xl:flex">
          <img
            src={DollarCoin}
            alt="Decorative Icon"
            className="w-[44px] h-[44px] slow-spin"
            style={{ animationDelay: '0s' }}
          />
        </div>
        <div className="absolute left-[calc(50%+599.41px)] top-[639.66px] translate-x-[-50%] w-[61.5px] h-[61.5px] items-center justify-center transform rotate-[8.641deg] hidden xl:flex">
          <img src={Film} alt="Decorative Icon" className="w-[54px] h-[54px] slow-spin" style={{ animationDelay: '0s' }} />
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <CSTertiaryBtn 
            name="Learn more about CS" 
            onClick={() => handleScrollTo("/", "how-it-works")}
          />
          <Link to="/esign">
            <CSPrimaryBtn name="Start earning today" variant="live" />
          </Link>
        </div>

      </div>
      <Statistics />
    </div>
  );
}

